import { render, staticRenderFns } from "./GaragesIcon.vue?vue&type=template&id=2a5b5cbc&scoped=true"
var script = {}
import style0 from "./GaragesIcon.vue?vue&type=style&index=0&id=2a5b5cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b5cbc",
  null
  
)

export default component.exports